import React, { useState } from 'react';

interface PartnerImageUploadProps {
  onChange?: (url: string) => void;
}

export default function PartnerImageUpload({ onChange }: PartnerImageUploadProps) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string>('');

  const handleFile = (file?: File | null) => {
    if (!file) return;
    
    setError('');
    
    const allowed = ['image/jpeg', 'image/png', 'image/webp'];
    if (!allowed.includes(file.type)) {
      setError('Only JPEG, PNG or WEBP files are allowed');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setError('File too large (maximum 5MB allowed)');
      return;
    }

    try {
      const blobUrl = URL.createObjectURL(file);
      if (onChange) onChange(blobUrl);
      if (inputRef.current) inputRef.current.value = '';
    } catch (e) {
      console.error('Failed to process image', e);
      setError('Failed to process image');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    handleFile(file);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleClick}
        className="px-3 py-1 bg-blue-600 text-white rounded text-sm"
      >
        Upload client logo
      </button>

      <input
        ref={inputRef}
        type="file"
        accept="image/png, image/jpeg, image/webp"
        onChange={handleInputChange}
        className="hidden"
        data-testid="partner-image-upload"
      />

      {error && (
        <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2 mt-2">
          {error}
        </div>
      )}
    </div>
  );
}
